import Collapse from './Collapse';


Collapse.install = function(Vue) {
  Vue.component(Collapse.name, Collapse);
};

export default Collapse;
